import React from 'react';

import './index.scss';
import logoRecruit from 'assets/logo-hd.png';
import PcTitle from 'components/molecules/PcTitle';

const PcHeader = ({
  title,
  state,
  path,
}) => {
  const isThanksPage = path.includes('thanks') ? true : false;
  return (
    <div className='PcHeader'>
      <div className="pc-header">
        <div className="pc-header-wrapper">
          <div className="pc-header-area">
            <div className="logo-area">
              <a href="/sol/contents/client/" target="_blank" rel="noopener noreferrer">
                <img className="" src={logoRecruit} alt="logo-recruit" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="pc-header-horizon" />
      <div className="pc-title">
        <PcTitle
          title={title}
          state={state}
          path={path}
        />
      </div>
    </div>
  );
};

export default PcHeader;
